const ufeApi = require('services/api/ufeApi');
const urlUtils = require('utils/Url');
const { addBrowseExperienceParams } = require('utils/Api');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Type+Ahead+Search+API

function searchTypeAhead(query, includeOnlyProducts = false, suggestions = {}) {
    const constructorSessionID = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();
    const constructorClientID = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const isNLPSearchEnabled = Sephora.configurationSettings.isNLPSearchEnabled;
    const isNLPInstrumentationEnabled = Sephora.configurationSettings.isNLPInstrumentationEnabled;
    const lastParam = includeOnlyProducts ? '&includeOnlyProducts=true' : '';
    const { productSuggestions = 6, searchSuggestions = 3 } = suggestions;
    let url = `/api/catalog/search/?type=typeahead&q=${encodeURIComponent(
        query
    )}${lastParam}&searchSuggestions=${searchSuggestions}&productSuggestions=${productSuggestions}`;

    if (isNLPInstrumentationEnabled) {
        if (isNLPSearchEnabled && constructorSessionID && constructorClientID) {
            url = url + `&constructorSessionID=${constructorSessionID}&constructorClientID=${constructorClientID}&targetSearchEngine=nlp`;
        }
    } else {
        url = url + '&targetSearchEngine=nlp';
    }

    const opts = {};

    addBrowseExperienceParams(opts);

    if (Object.keys(opts).length) {
        url += '&' + urlUtils.makeQueryString(opts);
    }

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = searchTypeAhead;
